export function isPaidVenue(
  venue?: { type?: unknown; string_type?: unknown } | null
) {
  return (
    venue?.type === 1 ||
    venue?.type === '1' ||
    String(venue?.string_type ?? '').toLowerCase() === 'paid'
  )
}
